import React, { createContext, useContext, useCallback, useRef } from 'react';

const RefreshContext = createContext();

export const RefreshProvider = ({ children }) => {
  const refreshFunctions = useRef(new Map());

  const registerRefreshFunction = useCallback((key, refreshFn) => {
    refreshFunctions.current.set(key, refreshFn);
  }, []);

  const unregisterRefreshFunction = useCallback((key) => {
    refreshFunctions.current.delete(key);
  }, []);

  const triggerRefresh = useCallback((key) => {
    const refreshFn = refreshFunctions.current.get(key);
    if (refreshFn && typeof refreshFn === 'function') {
      refreshFn();
    }
  }, []);

  const triggerAllRefreshes = useCallback(() => {
    refreshFunctions.current.forEach((refreshFn) => {
      if (typeof refreshFn === 'function') {
        refreshFn();
      }
    });
  }, []);

  return (
    <RefreshContext.Provider
      value={{
        registerRefreshFunction,
        unregisterRefreshFunction,
        triggerRefresh,
        triggerAllRefreshes
      }}
    >
      {children}
    </RefreshContext.Provider>
  );
};

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error('useRefresh must be used within a RefreshProvider');
  }
  return context;
}; 